export const LOGIN_TERMS_NOTICE_LINES: readonly string[] = ['By proceeding, you agree to our Terms of Service and Privacy Policy.', 'Contact support for further questions.'];
